
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart/[[...slug]]",
      function () {
        return require("private-next-pages/cart/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart/[[...slug]]"])
      });
    }
  